module.exports = __webpack_public_path__ + "static/media/lineto-brown-bold-c.a8863e89.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lineto-brown-bold-c.ttf
// module id = 70
// module chunks = 0